export default [
    {
        comment: 'add . at the end of the sentence',
        error_id: 'ENCR-01',
        data: [
            {cross_section: '43002', side: 'Left'},
            {cross_section: '43002', side: 'Right'},
        ]
    },
    {
        comment: '',
        error_id: 'ENCR-02',
        data: [
            {cross_section: '43002', side: 'Left'},
            {cross_section: '43002', side: 'Right'},
        ]
    },
    {
        comment: '',
        error_id: 'ENCR-03',
        data: [
            {cross_section: '43002', side: 'Left'},
            {cross_section: '43002', side: 'Right'},
        ]
    },
    {
        comment: '',
        error_id: 'ENCR-04',
        data: [
            {cross_section: '43002', side: 'Left', side_2: 'right'},
            {cross_section: '43002', side: 'Right', side_2: 'left'},
        ]
    },
    {
        comment: '',
        error_id: 'ENCR-00',
        data: [
            {cross_section: '43002'},
            {cross_section: '43002'},
        ]
    }
]